import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import theme from './modules/theme'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: { user, theme },
  getters: {
    token: state => state.user.token,
    userInfo: state => state.user.userInfo,
    themeColor: state => state.theme.themeColor
  }
})